'use client'

import Link from 'next/link'
import { useTranslation, I18nextProvider } from 'react-i18next'
import i18n from '@/lib/i18n'

// CWV-Rollout Phase 9 (Auftrag 31.07.2026): fuer eine URL, die KEINEM
// Routensegment entspricht (z. B. ein komplett unbekannter Pfad), rendert
// Next.js dieses Root-not-found.tsx OHNE dass irgendein verschachteltes
// Layout ((public)/layout.tsx, (dashboard)/layout.tsx, ...) zuvor
// gematcht/gerendert wurde -- der Provider-Baum liegt seit diesem Umbau
// aber genau in diesen verschachtelten Layouts, nicht mehr im Root-Layout.
// Eigene, in sich geschlossene I18nextProvider-Bindung hier stellt sicher,
// dass useTranslation() unabhaengig davon funktioniert, ob ein Ahnen-
// Provider bereits existiert (verschachtelte Provider mit derselben
// i18n-Instanz sind unschaedlich, falls doch einer da ist).
function NotFoundContent() {
  const { t } = useTranslation()
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4">
      <h1 className="text-6xl font-bold text-muted-foreground">404</h1>
      <p className="text-xl font-semibold">{t('notFound.title')}</p>
      <p className="text-sm text-muted-foreground">{t('notFound.description')}</p>
      <Link href="/dashboard" className="mt-4 text-primary hover:underline">
        → {t('notFound.backToDashboard')}
      </Link>
    </div>
  )
}

export function NotFoundView() {
  return (
    <I18nextProvider i18n={i18n}>
      <NotFoundContent />
    </I18nextProvider>
  )
}
